export const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
      width="24"
      height="24"
      {...props}
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
};
